module.exports = __webpack_public_path__ + "img/card-type.7a408e45.7a408e45.svg";